import React from "react";
import { Reveal, Ornament, PETROL } from "@/components/home/homeUi";

export default function HomeHero() {
  return (
    <section
      data-testid="home-hero"
      className="relative px-6 md:px-10 pt-28 md:pt-32 pb-10 md:pb-12"
      style={{
        background:
          "radial-gradient(ellipse 65% 55% at 50% 30%, rgba(214,186,128,0.24), rgba(232,214,178,0.10) 55%, rgba(249,248,246,0) 100%)",
      }}
    >
      <div className="relative max-w-4xl mx-auto text-center">
        <Reveal>
          <h1
            data-testid="home-hero-title"
            className="font-serif-display text-[38px] sm:text-[48px] md:text-[58px] xl:text-[64px] leading-[1.08] text-graphite tracking-tight"
          >
            A családi dinamikák és az emberi kapcsolódások{" "}
            <em className="text-gold" style={{ fontStyle: "italic" }}>
              új dimenziója
            </em>
          </h1>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8 md:mt-10 flex items-center justify-center gap-4">
            <span className="h-px w-8" style={{ background: PETROL, opacity: 0.45 }} aria-hidden="true" />
            <p
              data-testid="home-hero-eyebrow"
              className="font-body text-[11px] md:text-[12px] tracking-[0.38em] uppercase text-gold"
            >
              Forrás-Kód® Kísérés
            </p>
            <span className="h-px w-8" style={{ background: PETROL, opacity: 0.45 }} aria-hidden="true" />
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p
            data-testid="home-hero-subtitle"
            className="mt-7 md:mt-8 font-serif-display italic text-graphite text-[21px] sm:text-[24px] md:text-[27px] leading-[1.5] max-w-2xl mx-auto"
          >
            Az egység belül kezdődik, majd kapcsolódásról kapcsolódásra épül tovább.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export function HomeSupplement() {
  return (
    <section data-testid="home-supplement" className="px-6 md:px-10 pb-10 md:pb-14">
      <Reveal className="text-center">
        <Ornament className="mb-5" />
        <p
          data-testid="home-hero-supplement"
          className="font-serif-display text-graphite text-[20px] sm:text-[22px] md:text-[25px] leading-[1.6] max-w-2xl mx-auto"
        >
          Új nézőpontok. Tiszta emberi értékek. Tudatos választások.
          <br />
          <span className="italic text-gold">Egy új kapcsolódási kultúra lehetősége.</span>
        </p>
      </Reveal>
    </section>
  );
}
